/**
 * A ref callback that focuses its element when the element mounts. It is for
 * a control the user has just revealed — an inline editor opened from the
 * value it edits, a field behind a disclosure, the next step of a form — so
 * focus follows the action that revealed it. Never attach it to a control
 * present at page load, where moving focus skips everything before it. A
 * dialog or popover already moves focus to its first control when it opens.
 *
 * Its identity never changes, so React calls it only when the element mounts.
 */
export function focusOnMount(node: HTMLElement | null) {
  node?.focus()
}
